import QRCodeCustomGenerator from "components/QRCodeCustomGenerator";

const IEESCustomQRCodes = () => {
    return (
        <>
            <QRCodeCustomGenerator urlPath={'/watoms/pms'} />
            <QRCodeCustomGenerator urlPath={'/vtc-trainees-registration'} />
        </>
    )
}

export default IEESCustomQRCodes;